import api from "../services/authService";

// Authenticated (owner-facing) API for the "share a whole folder externally"
// feature. Mirrors service/matter.js's document external-share wrappers
// (fetchExternalShareDetail / externalShare / revokeShare / generatePassword)
// but targets a folder instead of a document, and works for both
// matter-scoped folders and personal (My Files) folders — the backend
// derives matter scope from the folder itself.
//
// The same screen also opens from the top of a client's file (Matthew,
// 10/30: the file's own share button is the same external share). There is
// no folder in hand then, so the file-level pair below asks by matter and
// answers for every link on the file, whichever folder it was made from.

export const fetchFolderExternalShareDetail = async ({ folder_id }) => {
  const response = await api.get(`/folders/${folder_id}/external-share-info/`);
  return response;
};

export const fetchMatterExternalShareDetail = async ({ matter_id }) => {
  const response = await api.get(`/matters/${matter_id}/external-share-info/`);
  return response;
};

export const externalFolderShare = async (payload) => {
  const response = await api.post(`/external-folder-share/create/`, payload);
  return response;
};

export const revokeFolderShare = async ({ folder_id }) => {
  const response = await api.post(`/folders/${folder_id}/revoke-all-external-shares/`);
  return response;
};

export const revokeMatterShares = async ({ matter_id }) => {
  const response = await api.post(`/matters/${matter_id}/revoke-all-external-shares/`);
  return response;
};
